if (!customElements.get('knowledge-hotspots')) {
  customElements.define(
    'knowledge-hotspots',
    class KnowledgeHotspots extends HTMLElement {
      constructor() {
        super();
        this.hotspotButtons = this.querySelectorAll('[data-hotspot]');
        this.closeOverlayButtons = this.querySelectorAll('[data-hide-overlay]');
        this.hotspotReveals = this.querySelectorAll('[data-hotspot-target]');
        this.hotspotRevealsMobile = this.querySelectorAll('[data-hotspot-target-mobile]');
        this.mobileSubheading = this.querySelector('[data-mobile-subheading]');
        this.staticContent = this.querySelector('[data-static-content]');

        // Esc listener to close overlays
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeAllReveals());

        this.addEventListener('click', (event) => {
          // Check if clicked element is a hotspot or contains a preview-hotspot attribute
          const hotspot = event.target.hasAttribute('data-hotspot') ? event.target : null;
          const previewElement = event.target.closest('[data-preview-hotspot]');

          if (hotspot || previewElement) {
            this.closeAllReveals();

            // Get the target index from either the hotspot or preview element
            let targetContentIndex;
            if (hotspot) {
              const animatedElements = hotspot.querySelectorAll('[data-animated-element]');
              animatedElements.forEach((el) => {
                el.classList.add('pause');
              });
              targetContentIndex = hotspot.dataset.index;
            } else {
              targetContentIndex = previewElement.dataset.previewHotspot;
              // Also pause animations on the corresponding hotspot
              const correspondingHotspot = this.querySelector(`[data-hotspot][data-index="${targetContentIndex}"]`);
              if (correspondingHotspot) {
                const animatedElements = correspondingHotspot.querySelectorAll('[data-animated-element]');
                animatedElements.forEach((el) => {
                  el.classList.add('pause');
                });
              }
            }

            const targetContent = this.hotspotReveals[targetContentIndex];
            const targetMobileContent = this.hotspotRevealsMobile[targetContentIndex];

            targetContent.setAttribute('aria-hidden', 'false');
            targetMobileContent.setAttribute('aria-hidden', 'false');
            this.mobileSubheading.classList.add('hidden');
            this.closeOverlayButtons.forEach((button) => button.setAttribute('aria-hidden', 'false'));
            this.staticContent.setAttribute('aria-hidden', 'true');
          } else if (!event.target.closest('[data-hotspot-target]')) {
            this.closeAllReveals();
          }
        });
      }

      closeAllReveals() {
        this.hotspotButtons.forEach((button) => {
          const animatedElements = button.querySelectorAll('[data-animated-element]');
          animatedElements.forEach((el) => {
            el.classList.remove('pause');
          });
        });
        this.hotspotReveals.forEach((el) => {
          el.setAttribute('aria-hidden', 'true');
        });
        this.hotspotRevealsMobile.forEach((el) => {
          el.setAttribute('aria-hidden', 'true');
        });
        this.mobileSubheading.classList.remove('hidden');
        this.staticContent.setAttribute('aria-hidden', 'false');
        this.closeOverlayButtons.forEach((button) => button.setAttribute('aria-hidden', 'true'));
      }
    }
  );
}
